module.exports = __webpack_public_path__ + "bm.svg?e71b682812c95eea10adf0cd8763ecf3";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/bm.svg
// module id = 760
// module chunks = 27